/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout'

const publicAccount = {
  path: '/publicaccount',
  component: Layout,
  redirect: 'noredirect',
  name: 'PublicAccount',
  meta: {
    title: 'publicAccount',
    icon: 'wechat'
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/publicAccount/index'),
      name: 'IndexPublicAccount',
      meta: { title: 'indexPublicAccount' }
    },
    {
      path: 'news',
      component: () => import('@/views/publicAccount/news'),
      name: 'NewsPublicAccount',
      meta: { title: 'newsPublicAccount' }
    },
    {
      path: 'advert',
      component: () => import('@/views/publicAccount/advert'),
      name: 'AdvertPublicAccount',
      meta: { title: 'advertPublicAccount' }
    }
  ]
}

export default publicAccount
